type FastCheckoutCart = {
  amount_total?: number | null;
  remaining_cart_amount_after_points?: number | null;
  requires_payment_method?: boolean;
};

const hasPositivePayableAmount = (cart: FastCheckoutCart): boolean => {
  const payableAmount =
    cart.remaining_cart_amount_after_points ?? cart.amount_total;

  return typeof payableAmount !== "number" || payableAmount > 0;
};

export const shouldShowFastCheckoutPaymentOptions = (
  cart?: FastCheckoutCart | null,
): boolean => {
  if (!cart) return true;
  if (cart.requires_payment_method === false) return false;

  return hasPositivePayableAmount(cart);
};
